<template>
  <div>
    <div class="hred">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>
    <div style="    font-weight: 700;
    font-style: normal;
    font-size: 36px;text-align: center;margin-top: 40px;">机构评分进度查询</div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <img class="img " src="@/images/biaodan/u113.png">
    </div>
  </div>
  <!-- 表单1 -->
  <el-form ref="form" :model="form" label-width="80px" >
    <el-row>
      <el-col :span="24">
        <el-form-item  label-width="140px"  class="hang" label="机构名称" prop="orgName">
          <el-input class="inputs" v-model="form.orgName" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入机构名称</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item  label-width="140px"  class="hang" label="法人姓名" prop="orgHeader">
          <el-input class="inputs" v-model="form.orgHeader" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入法人姓名</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item  label-width="140px"  class="hang" label="手机号码" prop="orgHeaderPhone">
          <el-input class="inputs" v-model="form.orgHeaderPhone" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入法人手机号码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item  label-width="140px"  class="hang" label="图形验证码" prop="code">
          <el-input class="inputs" style="width: 25%" v-model="iconv" @input="inputnow"/>
          <img :src="this.baseUrl" class="buttons" @click="getimgcode"/>
          <span class="xing">*</span><span class="bei">请输入图形验证码</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label-width="140px" class="hang" label="短信验证码" prop="code">
          <el-input class="inputs" style="width: 25%" v-model="form.code" @input="inputnow"/>
          <div class="buttons" @click="getcode">{{ getcodetitle }}</div>
          <span class="xing">*</span><span class="bei">请输入短信验证码</span>
        </el-form-item>
      </el-col>
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons3" size="mini" @click="goIndex">返回首页</div>
      <div class="buttons2" size="mini" @click="querySubmit">查询</div>
    </el-row>
  </el-form>


  <!-- Unnamed (矩形) -->
  <div id="u58" class="ax_default label">
    <div id="u58_div" class=""></div>
    <div id="u58_text" class="text ">
      <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
      <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
      <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
    </div>
  </div>
</template>

<script>
import {getJindu, getcode, getimgcode} from '@/requst/api'
import {ElMessage} from "element-plus";
export default {
  name: 'BaoBei',
  data() {
    return {
      baseUrl: '',//图形验证码
      icon: 0,
      iconv: '',
      getcodetitle: '获取短信验证码',
      form: {
        "orgName": "",
        "orgHeader": "",
        "orgHeaderIdCard": "",
        "orgHeaderPhone": "",
        "code": ''
      },
    }
  },
  created() {
    this.form = JSON.parse(localStorage.getItem('jindu')) ? JSON.parse(localStorage.getItem('jindu')) : this.form
    this.form.code = ''
    localStorage.setItem('cxjg','')
    this.getimgcode();
  },
  methods: {
    getstr() {
      this.icon = parseInt(new Date().getTime())
      return this.icon;
    },
    getcode() {
      let _this = this
      getcode({
        orgHeaderPhone: this.form.orgHeaderPhone,
        icode: this.iconv,
        str: this.icon,
      }).then(res => {
        //console.log(res)
        if (res.header.status == 0) {
          ElMessage.success('获取成功')
          _this.codetitle = 59
          setInterval(function () {
            _this.codetitle = _this.codetitle - 1
          }, 1000)
        }else if(res.header.status == 6 || res.header.status == 7){
            this.getimgcode();
            ElMessage.error(res.header.msg)
        } else {
            ElMessage.error(res.header.msg)
            //短信验证码已过期
            if(res.header.status == 21){
                this.form.code="";
            }
        }
      })
    },
    /*获取图形验证码*/
    getimgcode() {
      getimgcode({
        str: this.getstr()
      }).then(res => {
        //console.log(res.data)
        this.baseUrl = 'data:image/png;base64,' + res.data
        // this.baseUrl = 'data:image/png;base64,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'
      })
    },
    inputnow() {
      localStorage.setItem('jindu', JSON.stringify(this.form))
    },
    goIndex(){
        this.$router.push('/')
    },
    querySubmit(){
      getJindu(this.form).then(res=>{
          console.log(res)
        if(!res.data){
          ElMessage.error(res.header.msg)
          //短信验证码已过期
          if(res.header.status == 21){
              this.form.code="";
          }
        }
        if(res.data){
          localStorage.setItem('cxjg',JSON.stringify(res.data))
          this.$router.push('/scoreResult')
        }
      })

    }


  }
}
</script>
<style scoped>

#u58 {
  margin-top: 40px;
  background: rgb(242, 242, 242);
  height: 120px;
  padding: 10px 0;
  font-size: 16px;
}

#u51_img {
  width: 1000px;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

.jindu {
  margin-top: 20px;
  display: flex;
  margin-left: 100px;
}

.jindu .p1 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #CCCCCC;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span1 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #CCCCCC;
}

.jindu .p2 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #FF0000;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span2 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #FF0000;
}


.imgx {
  margin-left: -25px;
}

.jindu div {
  margin-left: 20px;
}

.hang {
  margin-left: 150px;
  color: black;
  font-size: 16px;
}

.inputs {
  width: 40%;
  margin-left: 10px;
}

.selects {
  width: 40%;
  margin-left: 10px;
}

.xing {
  color: red;
  font-size: 18px;
  margin-left: 5px;
}

.bei {
  font-size: 16px;
  margin-left: 30px;
  color: #c9c9c9;
}


.el-form-item label {
  color: black;
  font-size: 16px;
}

.buttons {
  cursor: pointer;
  border-width: 0px;
  width: 15%;
  height: 30px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
}

.buttons1 {
  cursor: pointer;
  border-width: 0px;
  width: 40px;
  text-align: center;
  height: 30px;
  background: inherit;
  background-color: #409eff;
  border: none;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons2 {
  cursor: pointer;
  position: relative;
  left: 39%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
  line-height: 45px;
}

.buttons3 {
    cursor: pointer;
    position: relative;
    left: 25%;
    width: 190px;
    height: 45px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(255, 51, 51, 1);
    border-radius: 3px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #FF3333;
    text-align: center;
    line-height: 45px;
}


</style>
